import React from "react";

import WHeader from "./w_header";
import WBody   from "./w_body";

const WTable = (props) => {

  const {
    header,
    first_row,
    bom_parameters,
    workbook,
  } = props;

  if(!workbook || workbook.length <= 0) return null;

  return (
    <table className="table fixed_header">
      {bom_parameters && 
        <WHeader bom_parameters={bom_parameters}/>
      }
      {workbook &&
        <WBody
          header={header}
          first_row={first_row}
          bom_parameters={bom_parameters}
          w_body={workbook}/>
      }
    </table>
  )
}

export default WTable;